import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";
import { InputPassword } from "../../senha";

export const PasswordFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, errors,
}) => (
  <>
    <InputPassword
      campo={campo}
      getFieldValue={getFieldValue}
      handleInputChange={handleInputChange}
      modo={modo}
    />
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
